import axios from 'axios';

// Base URLs for different environments
const LOCAL_API_URL = 'http://localhost:5000';
const FIREBASE_HOSTING_API_URL = ''; // Use relative URL for Firebase Hosting without /api prefix
const CLOUD_FUNCTIONS_URL = 'https://us-central1-rizzologygpt.cloudfunctions.net';
const DEPLOYED_SERVER_URL = 'https://rizzologygpt.herokuapp.com'; // Add the deployed server URL

// Always use the deployed server URL as requested by the user
export const API_URL = DEPLOYED_SERVER_URL;
export const FUNCTIONS_URL = CLOUD_FUNCTIONS_URL;

// Create axios instances with CORS headers
export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: false // Changed to false to avoid CORS preflight issues
});

export const functionsClient = axios.create({
  baseURL: FUNCTIONS_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: false // Changed to false to avoid CORS preflight issues
});

// API endpoints - Remove /api prefix based on the errors
export const endpoints = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    verify: '/auth/verify'
  },
  subscription: {
    status: '/subscription/status',
    create: '/subscription/create'
  },
  payment: {
    create: '/payment/create-payment', // Removed /api prefix
    verify: '/payment/verify'
  },
  vectorshift: {
    proxy: '/proxy/vectorshift'
  }
};

// Fallback mechanism for CORS errors
const handleCorsError = async (config) => {
  console.log('Attempting CORS fallback for:', config.url);
  
  // For development, return mock data
  if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    if (config.url.includes('subscription/status')) {
      return {
        data: {
          isActive: true,
          type: 'monthly',
          startDate: new Date().toISOString(),
          expiryDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
          paymentId: 'mock_payment_' + Date.now(),
          amount: 99.99,
          currency: 'ZAR'
        }
      };
    }
    
    if (config.url.includes('payment/create-payment')) {
      return {
        data: {
          id: 'mock_session_' + Date.now(),
          // Always use live key for real payments
          publicKey: 'pk_live_40625e75bVyGRYGd7fb4'
        }
      };
    }
  }
  
  return { error: 'CORS error' };
};

// Add response interceptor to handle CORS errors
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
      console.warn('CORS error detected, using fallback mechanism');
      return handleCorsError(error.config);
    }
    return Promise.reject(error);
  }
);

// Add authorization interceptor
apiClient.interceptors.request.use(async (config) => {
  try {
    // Get token from localStorage or your auth service
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  } catch (error) {
    console.error('Error in request interceptor:', error);
    return config;
  }
});

functionsClient.interceptors.request.use(async (config) => {
  try {
    // Get token from localStorage or your auth service
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  } catch (error) {
    console.error('Error in functions interceptor:', error);
    return config;
  }
});

export default {
  API_URL,
  FUNCTIONS_URL,
  apiClient,
  functionsClient,
  endpoints
}; 